import { ModalWrapper } from 'components/ModalWrapper/ModalWrapper';
import { VideoPlayer } from 'components/VideoPlayer/VideoPlayer';
import { VideoData } from 'models';
import React, { FC, useEffect, useState } from 'react';

interface Props {
  active: boolean;
  video: VideoData;
  videos?: Array<VideoData>;
  autoplay?: boolean;
  autoplayNext?: boolean;
  onRequestClose: () => any;
}

export const VideoModal: FC<Props> = ({
  active,
  video,
  videos,
  autoplay = false,
  autoplayNext = false,
  onRequestClose,
}) => {
  const [shouldAutoplay, setShouldAutoplay] = useState<boolean>(autoplay);
  const [show, setShow] = useState<boolean>(true);
  const [currentVideo, setCurrentVideo] = useState<VideoData>(video);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState<number>(
    videos && videos.length ? videos.findIndex((element) => element.video_url === video.video_url) : 0
  );

  useEffect(() => {
    setCurrentVideo(video);
    setSelectedVideoIndex(
      videos && videos.length ? videos.findIndex((element) => element.video_url === video.video_url) : 0
    );
  }, [video, videos]);

  const onClose = () => {
    onRequestClose();
  };

  const onVideoEnds = () => {
    setShow(false);
    if (!videos || !videos.length) return;
    const currentVideoIndex = videos.findIndex((video) => video.video_url === currentVideo.video_url);
    if (currentVideoIndex < 0) return;
    const newVideoIndex: number = (currentVideoIndex + 1) % videos.length;
    const newVideo = videos[newVideoIndex];
    setShouldAutoplay(newVideoIndex === selectedVideoIndex ? false : autoplayNext);
    setCurrentVideo(newVideo);
    setShow(true);
  };

  return (
    <ModalWrapper
      isOpen={active}
      options={{ fillSmallerScreens: false }}
      onRequestClose={() => onClose()}
      customStyles={{
        closeButton: { color: 'white' },
        modalContent: {
          borderRadius: 0,
          background: 'black',
          desktop: { padding: '0px' },
          tablet: { padding: '0px' },
          mobile: { padding: '0px' },
        },
      }}>
      {!currentVideo || !show ? null : (
        <VideoPlayer
          src={currentVideo.video_url}
          options={{
            aspectRatio: 16 / 9,
            title: currentVideo.video_title,
          }}
          data={currentVideo}
          autoplay={shouldAutoplay}
          onEndCallback={() => onVideoEnds()}
        />
      )}
    </ModalWrapper>
  );
};
